import Icon1 from "assets/img/services/img_notarization.png";
import Icon2 from "assets/img/services/img_business-translations.png";

export type ServiceRowObj = {
  id: number;
  icon: string;
  title: string;
  description: string;
  price: number;
  perPageUsd?: number;
  group: "Certified" | "Standard";
  key: string;
};

export const servicesData: ServiceRowObj[] = [
  // Certified services
  {
    id: 1,
    icon: Icon1,
    title: "Notarization",
    description: "Get your certificate notarized to verify authenticity.",
    price: 20,
    group: "Certified",
    key: "include_notarization",
  },
  {
    id: 3,
    icon: Icon2,
    title: "Expedited turnaround",
    description: "Get your translation delivered within 12-24 hours guaranteed.",
    price: 0,
    perPageUsd: 10,
    group: "Certified",
    key: "include_expedited_turnaround",
  },
  {
    id: 4,
    icon: Icon2,
    title: "Mailed hard copy",
    description: "Get a hard copy of your translation by mail.",
    price: 20,
    group: "Certified",
    key: "include_mail_hard_copy",
  },
  // Standard services
  {
    id: 5,
    icon: Icon2,
    title: "Proofreading",
    description: "After completion, an expert will proofread your translation.",
    price: 0,
    perPageUsd: 12.5,
    group: "Standard",
    key: "include_proofreading",
  },
  {
    id: 6,
    icon: Icon2,
    title: "Expedited turnaround",
    description: "Get your translation delivered within 12-24 hours guaranteed.",
    price: 0,
    perPageUsd: 10,
    group: "Standard",
    key: "include_expedited_turnaround",
  },
  {
    id: 7,
    icon: Icon2,
    title: "Desktop publishing",
    description: "Have an expert designer format your translation.",
    price: 0,
    perPageUsd: 10,
    group: "Standard",
    key: "include_desktop_publishing",
  },
];
